import type { LucideIcon } from "lucide-react";
import type { CSSProperties } from "react";

export interface ModuleCardProps {
  title: string;
  meta: string;
  Icon: LucideIcon;
  accent: string;
  delayMs?: number;
  onClick?: () => void;
}

/**
 * Single home-screen module tile. Glass-panel + rim light + per-instance accent.
 * Accent drives the top-inset stripe, icon chip, and focus ring. Card animates
 * in with a staggered delay (--delay) so the home grid feels orchestrated.
 */
export function ModuleCard({ title, meta, Icon, accent, delayMs = 0, onClick }: ModuleCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${title} öffnen – ${meta}`}
      className="module-card home-card-enter"
      style={
        {
          "--accent": accent,
          "--delay": `${delayMs}ms`,
        } as CSSProperties
      }
    >
      <div className="module-card-icon">
        <Icon className="size-7" strokeWidth={2.1} aria-hidden />
      </div>

      <div className="mt-4 flex flex-col gap-1">
        <div className="module-card-title">{title}</div>
        <div className="module-card-meta">{meta}</div>
      </div>
    </button>
  );
}
